import { render, staticRenderFns } from "./WXPay.vue?vue&type=template&id=2d32876d&"
import script from "./WXPay.vue?vue&type=script&lang=js&"
export * from "./WXPay.vue?vue&type=script&lang=js&"
import style0 from "./WXPay.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports